<script lang="ts">
  export let on: boolean = true;
</script>

<label class="inline-block relative cursor-pointer">
  <input
    class="absolute w-0 h-0 opacity-0"
    bind:checked={on}
    type="checkbox"
    {...$$restProps}
  />

  <div class="switch-bar">
    <div class="switch-circle" class:on={on}></div>
  </div>
</label>

<style lang="postcss">
  .switch-bar {
    @apply relative w-[30px] h-5 rounded-[10px] bg-primary-datadocs-blue;
  }

  .switch-circle {
    @apply absolute w-3.5 h-3.5 rounded-full bg-white;
    left: 3px;
    top: 3px;
    transition: left 0.15s ease-in-out;
  }

  .switch-circle.on {
    left: calc(100% - 17px);
    top: 3px;
  }
</style>